export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Profile-Gray-ab6d62ecfe40f61ea696fc1d263dd528.svg";